module.exports = __webpack_public_path__ + "img/filter-type-back--active.3148d14b.svg";